<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_layers"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Scope <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-file label='Logo' v-model="resource.picture_id" width="200"></form-file>

                                <form-select label="Parent scope" multiple="false" v-model="resource.parent" :default="resource.parent_id" :options="scopes"></form-select>

                                <form-select label="Timezone" multiple="false" v-model="resource.timezone" :options="$store.state.timezones" :required="true"></form-select>

                                <form-select label="Succursale" multiple="false" v-model="resource.branch" :default="branch_id" :options="branches" v-if="branches"></form-select>

                                <form-text label="Slug" v-model="resource.slug" :required="true"></form-text>

                                <form-text label="Website" v-model="resource.website"></form-text>

                              </fieldset>

                                <fieldset>
                                  <h3>Correspondance e-mail</h3>
                                  <p class="headline"></p>

                                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                        <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                    </div>
                                  </div>

                                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                        <form-text :translate-key="'default_email_from_name'" :translations="resource.translations" :lang="client.id" :label="'Nom email'" v-model="resource.translations[client.id].default_email_from_name" :required="true"></form-text>
                                    </div>
                                  </div>

                                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                        <form-text :translate-key="'default_email_from'" :translations="resource.translations" :lang="client.id" :label="'Email'" v-model="resource.translations[client.id].default_email_from" :required="true"></form-text>
                                    </div>
                                  </div>

                                </fieldset>

                                <fieldset>
                                  <h3>Correspondance SMS</h3>
                                  <p class="headline"></p>

                                  <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                        <form-text :translate-key="'default_sms_from_name'" :translations="resource.translations" :lang="client.id" :label="'Expéditeur SMS'" v-model="resource.translations[client.id].default_sms_from_name" :required="true"></form-text>
                                    </div>
                                  </div>

                                </fieldset>


                                <fieldset>
                                  <h3>Localisation</h3>
                                  <p class="headline"></p>

                                    <form-select label="Pays" multiple="false" v-model="resource.country" :default="resource.country_id" :options="$store.state.countries" :required="true"></form-select>
                                    <form-select label="Locales" multiple="true" v-model="resource.locales" :id="locale" :options="$store.state.locales" :required="true"></form-select>

                                </fieldset>

                            </tab>
                            <tab name="Theme">

                              <fieldset>
                                <h3>Attributs du scope</h3>
                                <p class="headline"></p>

                                <component-attributes v-model="resource" :locale="locale"></component-attributes>

                              </fieldset>

                            </tab>
                            <tab name="Analytics" v-if="$store.state.modules.indexOf('shop')>=0">

                                <fieldset>
                                    <h3>Configuration Analytics</h3>
                                    <p class="headline">Cette rubrique permet d'afficher les données de votre compte Google Analytics</p>

                                    <form-file label='Creditentials JSON' v-model="resource.ga_json_id" width="100"></form-file>
                                    <form-text label="View Id" v-model="resource.ga_view_id"></form-text>
                                    <form-toggle label="Auto-update order with sources" v-model="resource.order_ga_source_medium"></form-toggle>
                                </fieldset>

                                <fieldset>
                                    <h3>Notifications statistiques</h3>
                                    <p class="headline"></p>

                                    <form-toggle label="Notification" v-model="resource.order_statistics"></form-toggle>
                                    <div v-if="resource.order_statistics" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_statistics_email"></form-text>
                                        <form-toggle label="Show Visits" v-model="resource.ga_stat_visits"></form-toggle>
                                        <form-toggle label="Show goals" v-model="resource.ga_stat_goals"></form-toggle>
                                        <form-toggle label="Show Sales" v-model="resource.ga_stat_sales"></form-toggle>
                                    </div>

                                </fieldset>

                            </tab>
                            <tab name="Facturation">

                              <fieldset>
                                <h3>Configuration comptable</h3>
                                <p class="headline"></p>

                                <form-toggle label="Use Weebox for invoicing" v-model="resource.invoicing"></form-toggle>
                                <form-toggle label="Arrondir les prix (décimales de la devise)" v-model="resource.price_amount_rounding"></form-toggle>
                                <form-number label="Marge additionnelle sur la conversion de devise" v-model="resource.price_exchange_rate_fees" suffix="%"></form-number>
                                <form-select label="Devises" multiple="true" v-model="resource.currencies" :options="$store.state.currencies"></form-select>
                                <form-select label="Devise par défaut" multiple="false" v-model="resource.currency" :default="resource.currency_id" :options="resource.currencies" xv-if="resource.currencies.length"></form-select>
                                <form-toggle label="Prices TTC (BackEnd)" v-model="resource.is_ttc"></form-toggle>
                                <form-toggle label="Prices TTC (FrontEnd)" v-model="resource.website_is_ttc"></form-toggle>
                                <form-select label="Conditions de paiement par défaut" multiple="false" v-model="resource.payment_condition" :options="$store.getters.scope.payment_conditions"></form-select>
                                <form-select label="Taxe par défaut" multiple="false" v-model="resource.tax" :default="resource.default_tax_id" :options="$store.state.taxes"></form-select>
                                <form-text label="VAT Number" v-model="resource.vat_number"></form-text>

                              </fieldset>
                            </tab>
                            <tab name="E-commerce" v-if="$store.state.modules.indexOf('shop')>=0">

                              <fieldset>
                                <h3>Configuration</h3>
                                <p class="headline"></p>

                                <form-text label="Pickup distance in Km" v-model="resource.pickup_distance_limit"></form-text>
                                <form-text label="Nouveauté durée" v-model="resource.is_new_duration" suffix="jours"></form-text>
                                <form-text label="Pagination" v-model="resource.pagination"></form-text>
                                <form-select label="Sort by default" multiple="false" v-model="resource.pagination_order" :default="resource.pagination_order" :options="paginationOrders"></form-select>

                              </fieldset>

                              <fieldset>
                                <h3>Configuration stock</h3>
                                <p class="headline"></p>

                                <form-toggle label="Affichage du nombre de pièces stock dans le catalogue client" v-model="resource.stock_display_total_pieces"></form-toggle>
                                <div v-if="resource.stock_display_total_pieces">
                                  <form-text label="Nombre de pièces max affichées (au-delà du nombre spécifié, le système affiche 'En stock')" v-model="resource.stock_display_max_pieces" suffix="pièce(s)"></form-text>
                                </div>
                              </fieldset>

                              <fieldset>
                                <h3>Configuration Panier</h3>
                                <p class="headline"></p>

                                <form-numeric :label="'Validity in Cart (min)'" v-model="resource.order_validity_in_cart" default="60" :step="15"></form-numeric>
                                <form-toggle label="Préselection d'un mode de livraison lors de la commande" v-model="resource.order_shipping_preselect_per_default"></form-toggle>
                                <form-toggle label="Résumer le détail de la TVA dans le panier" v-model="resource.order_cart_resume_taxes"></form-toggle>
                                <form-toggle label="Autoriser l'emballage cadeau dans les produits" v-model="resource.order_has_gift"></form-toggle>

                              </fieldset>

                              <fieldset>
                                  <h3>Flux Google Shopping</h3>
                                <p class="headline"></p>

                                <div v-for="client in locales" class="external-link">
                                    <div class="flag"><img :src="'/src/assets/flags/'+client.id+'.svg'"></div>
                                    <div class="name"><input type="text" :value="catalog_uri + client.id"/></div>
                                    <div class="link"><a :href="catalog_uri + client.id" target="_blank"><i class="icon icon-icon_earth"></i></a></div>
                                </div>

                              </fieldset>

                              <fieldset>
                                  <h3>Callback en cas de paiement</h3>
                                  <p class="headline">Uniquement pour les administrateurs</p>

                                  <form-text label="Success" v-model="resource.gateway_callback_url_success" placeholder="{base}/checkout/{token}/{provider}/success"></form-text>
                                  <form-text label="Cancel" v-model="resource.gateway_callback_url_cancel" placeholder="{base}/checkout/{token}/{provider}/cancel"></form-text>
                                  <form-text label="Error" v-model="resource.gateway_callback_url_error" placeholder="{base}/checkout/{token}/{provider}/error"></form-text>

                              </fieldset>

                              <fieldset>
                                <h3>Checkout</h3>
                                <p class="headline">Configuration des champs optionnels au checkout</p>

                                <form-toggle label="Activer Google Place dans le checkout" hint="Vous pouvez définir si le checkout valide l'adresse via Google Place." v-model="resource.has_google_place_in_checkout"></form-toggle>
                                <form-toggle label="Checkout en une page" hint="Vous pouvez définir si le checkout se fait en une ou plusieurs étapes." v-model="resource.is_one_checkout"></form-toggle>
                                <form-numeric label="Créneaux horaires en minutes" hint="Utilisé pour définir les créneaux de livraison, par exemple: 16h15, 16h30, 16h45, etc." v-model="resource.delivery_schedule_fraction" default="15" :step="5"></form-numeric>

                                Téléphone fixe
                                <group-line-2>
                                  <form-toggle label="Visible" v-model="resource.checkout_phone_display"></form-toggle>
                                  <form-toggle label="Obligatoire" v-model="resource.checkout_phone_mandatory"></form-toggle>
                                </group-line-2>

                                Téléphone mobile
                                <group-line-2>
                                  <form-toggle label="Visible" v-model="resource.checkout_phone_mobile_display"></form-toggle>
                                  <form-toggle label="Obligatoire" v-model="resource.checkout_phone_mobile_mandatory"></form-toggle>
                                </group-line-2>

                                Date de naissance
                                <group-line-2>
                                <form-toggle label="Visible" v-model="resource.checkout_birthdate_display"></form-toggle>
                                <form-toggle label="Obligatoire" v-model="resource.checkout_birthdate_mandatory"></form-toggle>
                                </group-line-2>

                                Commentaire
                                <group-line-2>
                                  <form-toggle label="Visible" v-model="resource.checkout_comment_display"></form-toggle>
                                  <form-toggle label="Obligatoire" v-model="resource.checkout_comment_mandatory"></form-toggle>
                                </group-line-2>

                              </fieldset>

                              <fieldset>
                                <h3>Inscription / Compte client</h3>
                                <p class="headline"></p>

                                <form-toggle label="Compte client" hint="Autoriser l'inscription libre de compte client" v-model="resource.has_registration"></form-toggle>

                                <div v-if="resource.has_registration">
                                  <form-toggle label="Created notification" v-model="resource.registration_created"></form-toggle>
                                  <div v-if="resource.registration_created" class="form-published-email">
                                    <form-text label="Administrator Email" v-model="resource.registration_created_email"></form-text>
                                  </div>
                                </div>

                              </fieldset>

                              <fieldset>
                                <h3>Notifications de commande</h3>
                                <p class="headline"></p>

                                    <form-toggle label="Demande de contact - visite boutique" v-model="resource.contact_visit_form"></form-toggle>
                                    <form-toggle label="Demande de restockage - produit épuisé" v-model="resource.contact_restocking"></form-toggle>

                                    <form-toggle label="Created notification" v-model="resource.order_created"></form-toggle>
                                    <div v-if="resource.order_created" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_created_email"></form-text>
                                    </div>

                                    <form-toggle label="Success notification" v-model="resource.order_success"></form-toggle>
                                    <div v-if="resource.order_success" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_success_email"></form-text>
                                    </div>

                                    <form-toggle label="Paied notification / customer" v-model="resource.order_notification_paied_customer"></form-toggle>
                                    <form-toggle label="Paied notification / admin" v-model="resource.order_notification_paied_admin"></form-toggle>
                                    <div v-if="resource.order_notification_paied_admin" class="form-published-email">
                                      <form-text label="Administrator Email" v-model="resource.order_notification_paied_email"></form-text>
                                    </div>

                                    <form-toggle label="Pending notification" v-model="resource.order_pending"></form-toggle>
                                    <div v-if="resource.order_pending" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_pending_email"></form-text>
                                    </div>

                                    <form-toggle label="Inprogress notification" v-model="resource.order_inprogress"></form-toggle>
                                    <div v-if="resource.order_inprogress" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_inprogress_email"></form-text>
                                    </div>

                                    <form-toggle label="Shipped notification" v-model="resource.order_shipped"></form-toggle>
                                    <div v-if="resource.order_shipped" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_shipped_email"></form-text>
                                    </div>

                                    <form-toggle label="Delivered notification" v-model="resource.order_delivered"></form-toggle>
                                    <div v-if="resource.order_delivered" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_delivered_email"></form-text>
                                    </div>

                                    <form-toggle label="Canceled notification" v-model="resource.order_canceled"></form-toggle>
                                    <div v-if="resource.order_canceled" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_canceled_email"></form-text>
                                    </div>

                                </fieldset>

                                <fieldset>
                                    <h3>Notifications transporter</h3>
                                  <p class="headline"></p>

                                    <form-toggle label="Notification" v-model="resource.order_transporter"></form-toggle>
                                    <div v-if="resource.order_transporter" class="form-published-email">
                                        <form-text label="Administrator Email" v-model="resource.order_transporter_email"></form-text>
                                    </div>

                                </fieldset>

                            </tab>
                            <tab name="Calendrier">

                              <fieldset>
                                  <h3>Configuration du planning</h3>
                                  <p class="headline"></p>

                                  <group-line-3>
                                    <form-time label="Début de la journée" v-model="resource.schedule_min_time"></form-time>
                                    <form-time label="Fin de journée" v-model="resource.schedule_max_time"></form-time>
                                    <form-time label="Intervalle de réservation" v-model="resource.schedule_interval"></form-time>
                                  </group-line-3>
                              </fieldset>

                              <fieldset>
                                <h3>Réservation en ligne</h3>
                                <p class="headline">Par défaut, le panier est utilisé pour finaliser la réservation. Si actif, l'utilisateur finalise la réservation durant la prise du rendez-vous.</p>

                                <form-toggle label="Express checkout" v-model="resource.schedule_express_checkout"></form-toggle>

                              </fieldset>

                              <fieldset>
                                <h3>Notifications de rendez-vous</h3>
                                <p class="headline"></p>

                                <form-toggle label="Confirmation au client" v-model="resource.schedule_success_notification"></form-toggle>
                                <form-toggle label="Confirmation administrateur" v-model="resource.schedule_success_notification_admin"></form-toggle>
                                <div v-if="resource.schedule_success_notification_admin" class="form-published-email">
                                  <form-text label="Administrator Email" v-model="resource.schedule_success_notification_admin_email"></form-text>
                                </div>

                                <hr>
                                <h3>Rappel de rendez-vous</h3>
                                <p class="headline"></p>

                                <form-toggle label="Envoi de rappel" v-model="resource.schedule_reminder"></form-toggle>
                                <div v-if="resource.schedule_reminder" class="form-published-email">
                                  <form-text label="Délai de rappel" v-model="resource.schedule_reminder_hours" suffix="heure(s) avant"></form-text>
                                </div>

                              </fieldset>

                            </tab>
                            <tab name="Env">

                              <fieldset>
                                <h3>Fichier d'environnement</h3>
                                <p class="headline">Uniquement pour les administrateurs</p>

                                <div v-for="item in resource.env">
                                    <form-text :label="item.id" v-model="item.value"></form-text>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>
                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>


    import ScopeService from './ScopeService.js';
    import BranchService from "../config/branch/BranchService";
    import ComponentOpeningHours from "../../components/OpeningHours.vue";
    import ComponentSchedulable from "../../components/Schedulable.vue";
    import ComponentAttributes from "../../components/Attributes.vue";
    import UserService from '../scope/UserService.js';
    import Edit from '../../layouts/Edit.vue';

    export default {
        extends: Edit,
        components: {
            'component-opening-hours': ComponentOpeningHours,
            'component-schedulable': ComponentSchedulable,
            'component-attributes': ComponentAttributes,
        },
        data () {
            return {
                users: null,
                catalog_uri: "",
                branches: null,
                branch_id: null,
                defaultColor: '#000000',
                resource: {
                    workspaces: []
                },
                slotables: {
                    users: []
                },
                scopes: [],
                isLoading: false,
                paginationOrders: [
                    {id:'order_asc', name:'Manuel (ordre asc)'},
                    {id:'order_desc', name:'Manuel (ordre desc)'},
                    {id:'relevance', name:'Pertinence'},
                    {id:'new', name:'Nouveautés'},
                    {id:'name', name:'Nom'},
                    {id:'rating', name:'Rating'},
                    {id:'price_asc', name:'Prix croissants'},
                    {id:'price_desc', name:'Prix décroissants'}
                ],
                scheduleTypes: [
                    {id:'public-holiday', name: 'Jour férié'},
                    {id:'holiday', name: 'Vacances'},
                    {id:'closure', name: 'Fermeture'},
                    {id:'others', name: 'Autres'},
                ],
            }
        },
        mounted: function(){
            this.users = UserService;
        },
        methods:{
            resourceLoaded: function(){
                // Translations
                this.setTranslations(['name','default_email_from_name', 'default_email_from', 'default_sms_from_name']);
                if( this.resource.values ){
                    for( var i=0; i<this.resource.values.length ; i++){
                        this.setTranslationsTo(this.resource.values[i], ['name','default_email_from_name', 'default_email_from', 'default_sms_from_name']);
                    }
                }
                this.catalog_uri = window.apiUrl + "/" + this.resource.slug + '/v1/public/shop/catalog/products/rss?lang='
                this.slotables = this.resource.slotables || []
                this.resource.schedules = this.resource.schedules || []
                this.resource.currencies = this.resource.currencies || []
                this.resource.order_stock_low_value = this.resource.order_stock_low_value || 0

                // Attributes
                /*
                if(this.resource && this.resource.id != null) {
                    for(let attribute of this.resource.attributes){
                        this.resource[attribute.slug] = attribute.value;
                    }
                }*/

                this.branches = this.resource.branches
                this.branch_id = this.resource.branch_id

                ScopeService.query().then(response => {
                    this.scopes = [];
                    this.isLoading = false;

                    if(this.resource && this.resource.id != null) {
                        for(let item of response.data.data){

                            if((this.resource.parents.indexOf(item.id.toString()) < 0 && this.resource.children.indexOf(item.id.toString()) < 0)){
                                this.scopes.push(item);
                            }
                        }
                    }else{
                        this.scopes = response.data.data;
                    }

                })

                this.initialize()
            },
            addSchedulableSlot:function(){
                this.slotables.push({
                    id: null,
                    name: '',
                    color: ''
                });
            },
            removeSchedulableSlot:function(i){
                this.slotables.splice(i, 1);
            },
            getResource: function(){
                return ScopeService
            },
            submit: function(){

                let Resource = Object.assign({}, this.resource);

                if( !this.beforeUpdate(Resource) ){
                    return false;
                }

                Resource.slotables = this.slotables

                if( this.$route.meta.action == "edit" ){

                    this.getResource().update(this.$route.params.id, Resource).then((response) => {

                        this.$store.dispatch("user").then(() => {
                            this.$store.dispatch("load").then(() => {

                            });
                        });

                        this.$emit('refresh', this);
                        this.back();
                    })

                }else{

                    this.getResource().create(Resource).then((response) => {

                        this.$store.dispatch("user").then(() => {
                            this.$store.dispatch("load").then(() => {

                            });
                        });

                        this.$emit('refresh', this);
                        this.back();
                    })
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/scope/Edit.vue